<template>
    <div>
        <a-modal :visible="isShow" width="700px" title="拆包详情" :footer="null" @cancel="cancel" centered class="package_modal" :bodyStyle="{padding:'10px 20px'}">
            <a-tabs>
                <a-tab-pane v-for="(item,index) in packageList" :key="`packge${index}`" :tab="`包裹${index+1}（${item.list.length}）`">
                    <div class="content">
                        <a-table :data-source="item.list" :pagination="false" :rowKey="(record,index) => record.primary + index">
                            <a-table-column key="name" title="名称" data-index="name" ellipsis="true" width="70%" />
                            <a-table-column key="num" title="数量" data-index="num" align="center" />
                            <a-table-column key="weight" title="重量" data-index="weight" align="center">
                                <template slot-scope="weight">
                                    <span>{{Number(weight).toFixed(3)}}kg</span>
                                </template>
                            </a-table-column>
                            <span slot="footer">运费：￥{{item.freight}}</span>
                        </a-table>
                    </div>
                </a-tab-pane>
            </a-tabs>
            <div class="btn_confirm">
                <a-button @click="cancel">关闭</a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'PackageDetailModal',
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        packageList: {
            type: Array,
            required: false
        },
    },
    methods: {
        ok () {
            this.cancel()
        },
        cancel () {
            this.$emit('hidden', false)
        },
    },
}
</script>

<style scoped>
.package_modal {
    color: #333333;
}

.package_modal >>> .ant-tabs-nav-wrap {
    text-align: left;
}

.package_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}

.btn_confirm {
    text-align: center;
    margin-top: 20px;
}

.btn_confirm >>> .ant-btn {
    height: 35px;
    width: 100px;
}
.content {
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/order/PackageDetailModal.vue